import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";
const createBoundedUseStore = (store) => (selector) => {
  return useStore(store, selector && useShallow(selector));
};
export {
  createBoundedUseStore
};
//# sourceMappingURL=create-bounded-use-store.js.map
